function getIdFromUrl(url) {
    let arr=url.split('/');
    let id=arr[arr.length-2];
    return id
}
export default getIdFromUrl